import { FileExtendedDetails, FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { clientError } from 'sos-common/js/commonTypes/ClientError.types';

export interface StatsbidragFileUploaderProps {
  maxFile: number;
  fileHeading: string;
  fieldId: string;
  fieldName: string;
  caseId: string;
  maxFileSizeInMb?: number;
  mimeTypes?: string;
  isRequired: boolean;
  formElementName: string;
  type: string;
  autoFillValues: string[];
}

export interface StatsbidragFileUploaderState {
  fileUploadState: FileExtendedDetails[];
  serverResponseObject: StatsbidragFileUploaderServerResponse;
  clientError: clientError;
  isValid: boolean;
  isTouched: boolean;
}

export interface StatsbidragFileUploaderServerResponse {
  Files: ServerResponseFile[];
  CaseId: string;
  FileId: string;
  status: FileState;
}

export interface ServerResponseFile {
  Name: string;
  BilagaId: string;
}

export const NO_UPLOADED_FILES = 'Användaren har inte laddat upp någon fil.';

export const STATSBIDRAG_EPIFORMFILE_MIMETYPES =
  'text/xml,application/xml,text/html,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.graphics,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.presentation,application/vnd.oasis.opendocument.formula,application/pdf,text/rtf,application/rtf,text/plain,image/jpeg,image/png,image/tiff,image/bmp,image/x-bmp,image/x-ms-bmp,image/gif,application/postscript,audio/wav,audio/wave,audio/vnd.wave,audio/x-wav,audio/mpeg,audio/mp4,video/mp4,application/vnd.ms-asf,video/x-ms-asf,video/x-ms-wmv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msexcel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/mspowerpoint,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
